export default {
	getRule: state => state.rule,
	term: state => state.term
}
